import React, {useEffect, useState} from "react";
import "./style.scss";
import editButtonGrey from "../../../../assets/icons/editButtonGrey.svg";
import Deel from "../../../../assets/images/deel.png";
import ACH from "../../../../assets/images/ach.jpg";
import Swift from "../../../../assets/images/swift.png";
import Wire from "../../../../assets/images/wire.png";
import Paypal from "../../../../assets/images/paypal.png";
import VerifiedIcon from "../../../../assets/icons/tick-green-circle.svg";
import {useDispatch, useSelector} from "react-redux";
import {getPayoutList} from "../../../../store/reducers/accountSlice";
import {paymentMethods} from "../../../../utils/apis/payment";

function Banks({value, setValue, setIsLoading, refreshBanksDetails}) {
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();

  const [verifiedBanks, setVerifiedBanks] = useState([]);
  const fetchPaymentMethods = async () => {
    setIsLoading(true);
    const response = await paymentMethods(idToken, dispatch);

    const verifiedKeys = Object.keys(response)
      .filter((key) => {
        const array = response[key];
        return Array.isArray(array) ? array.length > 0 : !!Object.keys(array).length;
      })
      .map((key) => key.toUpperCase());

    setVerifiedBanks(verifiedKeys);
    setIsLoading(false);
  };
  useEffect(() => {
    fetchPaymentMethods();
  }, [refreshBanksDetails]);

  useEffect(() => {}, [verifiedBanks]);
  // const bankDetails = [
  //   {
  //     name: "Deel",
  //     desc: "Lorem ipsum dolor sit amet orem ipsum dolor sit ameconsectetur. ",
  //     verified: true,
  //     img: Deel,
  //   },
  //   {
  //     name: "ACH",
  //     desc: "Lorem ipsum dolor sit amet orem ipsum dolor sit ameconsectetur. ",
  //     verified: true,
  //     img: ACH,
  //   },
  //   {
  //     name: "Wire",
  //     desc: "Lorem ipsum dolor sit amet orem ipsum dolor sit ameconsectetur. ",
  //     verified: true,
  //     img: Wire,
  //   },
  //   {
  //     name: "Swift",
  //     desc: "Lorem ipsum dolor sit amet orem ipsum dolor sit ameconsectetur. ",
  //     verified: true,
  //     img: Swift,
  //   },
  //   {
  //     name: "Paypal",
  //     desc: "Lorem ipsum dolor sit amet consectetur.",
  //     verified: true,
  //     img: Paypal,
  //   },
  // ];
  const bankDetails = [
    {
      name: "Deel",
      desc: "Use Deel for swift and secure transactions tailored to your needs.",
      verified: verifiedBanks.includes("DEEL") ? true : false,
      img: Deel,
    },
    {
      name: "ACH",
      desc: "Effortless domestic transfers for your convenience and savings.",
      verified: verifiedBanks.includes("ACH") ? true : false,
      img: ACH,
    },
    {
      name: "BankWire",
      desc: "Select Bank Wire for direct, reliable transfers for your convenience.",
      verified: verifiedBanks.includes("WIRE") ? true : false,
      img: Wire,
    },

    {
      name: "SWIFT",
      desc: "Global transactions made swift, secure, and seamless.",
      verified: verifiedBanks.includes("SWIFT") ? true : false,
      img: Swift,
    },
    {
      name: "Paypal",
      desc: "Get paid with PayPal for convenient and seamless transactions.",
      verified: verifiedBanks.includes("PAYPAL") ? true : false,
      img: Paypal,
    },
  ];

  return (
    <div className="banks">
      <div className="banks_container">
        {bankDetails?.map((bank, idx) => {
          return (
            bank.name !== "Deel" &&
            bank.name !== "ACH" && (
              <div>
                <RadioBox
                  key={bank.name}
                  bank={bank}
                  index={idx + 1}
                  setValue={setValue}
                />
              </div>
            )
          );
        })}
      </div>
    </div>
  );
}

export default Banks;

const RadioBox = ({bank, index, setValue}) => {
  return (
    <div className="radiobox">
      <div className="radiobox_header">
        <div>
          <img
            style={{maxWidth: "40px"}}
            src={bank?.img}
            alt={bank?.name}
          />
          <p className="account_type">{bank?.name}</p>
          <p>{bank?.desc}</p>
        </div>
      </div>
      <div className="radiobox_details">
        {bank.verified && (
          <div>
            <img
              src={VerifiedIcon}
              alt={bank.name}
            />
            Verified
          </div>
        )}
        <div className="radiobox_buttons">
          <input
            type="radio"
            name="bank-radio"
          />
          <button
            onClick={() => {
              setValue(index);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="28"
              viewBox="0 0 30 30"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.8367 7.5049C18.5133 7.18161 18.0747 7 17.6175 7C17.1602 7 16.7217 7.18161 16.3983 7.5049L7.50527 16.3979C7.18184 16.7212 7.0001 17.1598 7 17.6171V22.1291C7 22.6094 7.39059 23 7.87085 23L21.6613 22.9991C21.89 22.9991 22.1093 22.9083 22.271 22.7466C22.4327 22.5849 22.5236 22.3656 22.5236 22.1369C22.5236 21.9082 22.4327 21.6889 22.271 21.5272C22.1093 21.3655 21.89 21.2747 21.6613 21.2747H14.8221L22.4951 13.6017C22.8184 13.2783 23 12.8398 23 12.3825C23 11.9253 22.8184 11.4867 22.4951 11.1633L18.8367 7.5049ZM12.3838 21.2747L21.2759 12.3825L17.6175 8.72409L8.72446 17.6171V21.2747H12.3838Z"
                fill="#071E0D"
                fill-opacity="0.2"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};
